import { useEffect, useRef } from 'react';

export default function useDebounce(delayMilliseconds: number): [(a: () => void) => void, () => boolean] {
	const timeout = useRef<NodeJS.Timeout | null>(null);
	const cancel = () => {
		const { current } = timeout;
		if (current !== null) {
			timeout.current = null;
			clearTimeout(current);
			return true;
		}
		return false;
	};
	const debounce = (callback: Function) => {
		cancel();
		timeout.current = setTimeout(() => {
			timeout.current = null;
			callback();
		}, delayMilliseconds);
	};

	useEffect(
		() => () => {
			cancel();
		},
		[]
	);

	return [debounce, cancel];
}
